/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Body from 'DesignSystem/Body/index'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function No({
  children,
  viewPath = "/App/Account/Content/Content/Home/MessageAlert/Content/No"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="No.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Fs': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-2-Fs': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-3-Fs': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-4-Fs': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bblr-5-Fs': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-Fs': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-7-Fs': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-8-Fs': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-9-Fs': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Body
  viewPath={`${viewPath}/Body`}
 color="#606060"
 text="No messages currently need your response"
/>
</div>
{children}
</React.Fragment>)
}